<div class="modal fade document-bulk-move-files-modal" [id]="modalId" msEscClose (escPressed)="cancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title text-break">
                    @if (fileCount() === 1) {
                        Move "{{ fileNodes()[0].name }}" to
                    } @else {
                        Move {{ fileCount() }} files to
                    }
                </h5>
            </div>

            <div class="modal-body px-4 pb-0">
                <p class="text-secondary small mb-3">
                    The files will inherit the destination folder's permission. Name collisions in the destination
                    auto-rename with <code>(1)</code>, <code>(2)</code>, etc.
                </p>

                <ms-folder-tree-picker
                    [rootNodes]="folderTree()"
                    [loadChildren]="loadChildren"
                    [(selected)]="selectedDestination"
                    emptyMessage="No folders are available as a destination." />

                @if (errorMessage()) {
                    <div class="alert alert-warning d-flex align-items-center gap-2 mt-3 mb-0" role="alert">
                        <fa-duotone-icon icon="triangle-exclamation" class="text-warning flex-shrink-0" secondaryOpacity="0.4" />
                        <div>{{ errorMessage() }}</div>
                    </div>
                }
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4 gap-2">
                <button type="button" class="btn btn-ms-secondary px-4" (click)="cancel()" [disabled]="isSubmitting()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary px-4" (click)="submit()" [disabled]="!canSubmit()">
                    @if (isSubmitting()) {
                        <span class="spinner-border spinner-border-sm me-2"></span>
                    }
                    Move
                </button>
            </div>
        </div>
    </div>
</div>
